import { render, staticRenderFns } from "./DiseaseEducation.vue?vue&type=template&id=736270b4&scoped=true&"
import script from "./DiseaseEducation.vue?vue&type=script&lang=ts&"
export * from "./DiseaseEducation.vue?vue&type=script&lang=ts&"
import style0 from "./DiseaseEducation.vue?vue&type=style&index=0&id=736270b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736270b4",
  null
  
)

export default component.exports